import { SlValidationResult } from '@ui/features/Trade/utils/validateStoppLossPrice';
import { TpValidationResult } from '@ui/features/Trade/utils/validateTakeProfitPrice';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import BigNumber from 'bignumber.js';
import { Dispatch, SetStateAction } from 'react';

import { GenericTradeParams, TpSlValueState } from '../../../types';
import { TPSLInputSection } from '../../TradeModule/TPSLInputSection';

export const EditTpSl = ({
  tp,
  setTp,
  sl,
  setSl,
  genericTradeParams,
  isPositionType,
  maxTpRatios,
  spreadPercentage,
  leverage,
  collateralUsd,
  tpValidation,
  slValidation,
}: {
  tp: TpSlValueState;
  setTp: Dispatch<SetStateAction<TpSlValueState>>;
  sl: TpSlValueState;
  setSl: Dispatch<SetStateAction<TpSlValueState>>;
  isPositionType: boolean;
  maxTpRatios: number | undefined;
  spreadPercentage: number;
  leverage: number;
  collateralUsd: BigNumber;
  tpValidation: TpValidationResult | undefined;
  slValidation: SlValidationResult | undefined;
} & GenericTradeParams) => {
  const isLong = genericTradeParams.isLong;
  const priceDisplayDecimals = useTokenDisplayDecimals(
    genericTradeParams.pair.baseSymbol,
    genericTradeParams.pair.priceDisplayDecimals,
  );

  return (
    <TPSLInputSection
      tp={tp}
      setTp={setTp}
      sl={sl}
      setSl={setSl}
      entryPrice={genericTradeParams.entryPrice.toNumber()} // for edit, the entry price ==== position entry price
      leverage={leverage}
      collateralUsd={collateralUsd}
      isLong={isLong}
      priceDisplayDecimals={priceDisplayDecimals}
      maxTpRatios={maxTpRatios}
      tpValidation={tpValidation}
      slValidation={slValidation}
      spreadPercentage={spreadPercentage}
      defaultTpEnabled={false}
      forceExpanded
    />
  );
};
